import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = {
    key: 0,
    class: "form-details"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tNotification Settings\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_8 = {
    name: "companyNotificationSummary",
    class: "clearfix"
};
const _hoisted_9 = {
    name: "contacts",
    class: "clearfix"
};
const _hoisted_10 = { class: "x_panel" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "x_title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\t\t\t\t\tContacts\r\n\t\t\t\t\t\t\t\t"),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" })
], -1 /* HOISTED */);
const _hoisted_12 = { class: "x_content" };
const _hoisted_13 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_14 = {
    id: "notificationContactsTable",
    class: "table table-hover bottom0 pw100"
};
const _hoisted_15 = { class: "v-align-top" };
const _hoisted_16 = { title: "Enable / disable system summary notifications" };
const _hoisted_17 = { title: "You can set how frequently system summary notifications are sent." };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("br", null, null, -1 /* HOISTED */);
const _hoisted_19 = ["id"];
const _hoisted_20 = { class: "v-align-middle" };
const _hoisted_21 = { class: "v-align-middle" };
const _hoisted_22 = { class: "v-align-middle" };
const _hoisted_23 = { class: "v-align-middle" };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "9"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_26 = [
    _hoisted_25
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CompanyNotificationSummaryVue = _resolveComponent("CompanyNotificationSummaryVue");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_input = _resolveComponent("b-form-input");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showTitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_CompanyNotificationSummaryVue, {
                            ref: "notificationsSummary",
                            companyId: _ctx.query.companyId
                        }, null, 8 /* PROPS */, ["companyId"])
                    ]),
                    _createTextVNode(),
                    _withDirectives(_createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("table", _hoisted_14, [
                                        _createElementVNode("thead", _hoisted_15, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, [
                                                    _createVNode(_component_SortableColumnComponent, {
                                                        sorter: _ctx.sorter,
                                                        column: { fieldName: 'DisplayName', title: 'Contact' }
                                                    }, null, 8 /* PROPS */, ["sorter"])
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("th", null, [
                                                    _createVNode(_component_SortableColumnComponent, {
                                                        sorter: _ctx.sorter,
                                                        column: { fieldName: 'EmailAddress', title: 'Email Address' }
                                                    }, null, 8 /* PROPS */, ["sorter"])
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("th", _hoisted_16, [
                                                    _createVNode(_component_SortableColumnComponent, {
                                                        sorter: _ctx.sorter,
                                                        column: { fieldName: 'SendSystemDigestEmails', title: 'Summary' }
                                                    }, null, 8 /* PROPS */, ["sorter"])
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("th", _hoisted_17, [
                                                    _createVNode(_component_SortableColumnComponent, {
                                                        sorter: _ctx.sorter,
                                                        column: { fieldName: 'SystemDigestNotificationInterval', title: '' }
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _renderSlot(_ctx.$slots, "title", {}, () => [
                                                                _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tSummary"),
                                                                _hoisted_18,
                                                                _createTextVNode("Interval (" + _toDisplayString(_ctx.displayedSummaryNotificationIntervalType) + ")\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                            ])
                                                        ]),
                                                        _: 3 /* FORWARDED */
                                                    }, 8 /* PROPS */, ["sorter"])
                                                ])
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    class: _normalizeClass({ 'deleted': item.isEnabled == false }),
                                                    id: item.notificationGroupId
                                                }, [
                                                    _createElementVNode("td", _hoisted_20, _toDisplayString(item.displayName), 1 /* TEXT */),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_21, _toDisplayString(item.emailAddress), 1 /* TEXT */),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_22, [
                                                        _createVNode(_component_b_form_checkbox, {
                                                            id: 'sendSystemDigestEmails-' + item.personId,
                                                            modelValue: item.sendSystemDigestEmails,
                                                            "onUpdate:modelValue": ($event) => ((item.sendSystemDigestEmails) = $event),
                                                            disable: _ctx.working
                                                        }, null, 8 /* PROPS */, ["id", "modelValue", "onUpdate:modelValue", "disable"])
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_23, [
                                                        (_ctx.isPowerShield)
                                                            ? (_openBlock(), _createBlock(_component_b_form_input, {
                                                                key: 0,
                                                                type: "number",
                                                                modelValue: item.systemDigestNotificationIntervalInMinutes,
                                                                "onUpdate:modelValue": ($event) => ((item.systemDigestNotificationIntervalInMinutes) = $event),
                                                                disable: _ctx.working,
                                                                onFocus: _cache[0] || (_cache[0] = ($event) => ($event.target.select())),
                                                                disabled: _ctx.disableIntervalInput(item)
                                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disable", "disabled"]))
                                                            : _createCommentVNode("v-if", true),
                                                        _createTextVNode(),
                                                        (!_ctx.isPowerShield)
                                                            ? (_openBlock(), _createBlock(_component_b_form_input, {
                                                                key: 1,
                                                                type: "number",
                                                                modelValue: item.systemDigestNotificationIntervalInDays,
                                                                "onUpdate:modelValue": ($event) => ((item.systemDigestNotificationIntervalInDays) = $event),
                                                                disable: _ctx.working,
                                                                min: _ctx.lowerSystemDigestInterval,
                                                                max: _ctx.upperSystemDigestInterval,
                                                                onFocus: _cache[1] || (_cache[1] = ($event) => ($event.target.select())),
                                                                disabled: _ctx.disableIntervalInput(item)
                                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "disable", "min", "max", "disabled"]))
                                                            : _createCommentVNode("v-if", true)
                                                    ])
                                                ], 10 /* CLASS, PROPS */, _hoisted_19));
                                            }), 256 /* UNKEYED_FRAGMENT */))
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("tfoot", null, [
                                            (_ctx.noData)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_24, _hoisted_26))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ], 512 /* NEED_PATCH */), [
                        [_vShow, _ctx.searchAttempted]
                    ])
                ])
            ])
        ])
    ]));
}
